// frontend/src/components/ui/LoadingSpinner.tsx

import React from 'react';

interface LoadingSpinnerProps {
  message?: string;
  size?: 'small' | 'medium' | 'large';
  className?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  message = "Caricamento...",
  size = 'medium',
  className = "",
}) => {
  const sizeClasses = {
    small: "h-4 w-4",
    medium: "h-8 w-8", 
    large: "h-12 w-12"
  };

  return (
    <div className={`flex items-center justify-center p-8 ${className}`}>
      <div className={`animate-spin rounded-full border-b-2 border-blue-600 mr-3 ${sizeClasses[size]}`}></div>
      <span className="text-gray-600">{message}</span>
    </div>
  );
};

export default LoadingSpinner;